import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'

const WARN_AT_SECONDS = 160
const EXPIRE_LIMIT = 1000
const MINUTE = 60

class CartNotificationsMenu extends Component {
  constructor() {
    super()
    this.state = {
      cart_items: [],
      coupons: [],
      noticeSent: false,
      closest_expiration: undefined,
      seconds_remaining: 0,
      is_loading: true,
    }
    this.tick = this.tick.bind(this)
  }

  componentDidMount() {
    this.get_cart_items()
  }

  get_cart_items() {
    axios.get('/cart/get_cart_items').then(({ data }) => {
      const cart_items = data.data.filter((x) => x.item_type === 'event')
      this.setState({
        cart_items,
        is_loading: false,
        coupons: data.data.filter((x) => x.item_type === 'coupon'),
      })
      if (cart_items.length) {
        const closest_expiration = cart_items.map((x) => x.reservation_expires).sort()[0]
        this.setState({ closest_expiration })
        this.start()
      }
    })
  }

  start() {
    this.frameId = requestAnimationFrame(this.tick)
  }

  tick() {
    const seconds_remaining = moment(this.state.closest_expiration).diff(moment(), 'seconds')
    if (seconds_remaining <= 0) {
      this.stop()
    } else if (seconds_remaining < EXPIRE_LIMIT) {
      if (seconds_remaining <= WARN_AT_SECONDS && this.state.noticeSent !== true) {
        alert('You have an item in your cart expiring soon!! Checkout now or the item will be removed')
        this.state.noticeSent = true
      }
      this.setState({ seconds_remaining }, () => (this.frameId = requestAnimationFrame(this.tick)))
    }
  }

  stop() {
    cancelAnimationFrame(this.frameId)
    this.setState({ is_loading: true })
    this.get_cart_items()
  }

  areItemsInCart() {
    return this.state.cart_items.length > 0 ? this.renderIfItemsInCart() : this.renderIfEmptyCart()
  }

  renderIfEmptyCart() {
    return (
      <li id="cart-link">
        <a className="text-center" href="/cart/training_list">
          Find Trainings
        </a>
      </li>
    )
  }

  renderIfItemsInCart() {
    return (
      <li>
        <a className="text-center" href="/cart/view_cart">
          View Cart
        </a>
        <p id="item-expiring">
          You have an item expiring in: {Math.floor(this.state.seconds_remaining / MINUTE)} minutes and{' '}
          {this.state.seconds_remaining % MINUTE} seconds
        </p>
      </li>
    )
  }

  renderCartItem(item, index) {
    return (
      <li id={`li-item-${index}`} key={index}>
        <span className="item">
          <span className="item-left">
            <span className="item-info">
              <span className="truncate">{item.title}</span>
              <span>${item.item_price}</span>
            </span>
          </span>
          <span className="item-right">
            <span className="pull-right">&nbsp;</span>
            <a className="btn btn-xs btn-default pull-right" href={`/cart/view_training/${item.product_id}`}>
              <i className="fa fa-fw fa-eye" />
            </a>
          </span>
        </span>
      </li>
    )
  }

  renderCartMenuButtonContent(item_count) {
    return (
      <span style={{ color: item_count ? 'white' : '' }} id="cart-txt">
        <span className="fa fa-fw fa-shopping-cart" />{' '}
        {this.state.is_loading && (
          <span className="ball-scale">
            <div style={{ margin: '-0.25em 0.5em', height: '16px', width: '16px' }} />
          </span>
        )}
        {!this.state.is_loading && (
          <span>
            {item_count} - {item_count == 1 ? 'Item' : 'Items'}
            <span className="caret" />
          </span>
        )}
      </span>
    )
  }

  renderCartMenu() {
    return (
      <ul className="dropdown-menu dropdown-cart" role="menu">
        <div id="item_list">{this.state.cart_items.map(this.renderCartItem)}</div>
        <li className="divider" />
        {this.areItemsInCart()}
        <li id="history-link">
          <a className="text-center" href="/user/order_history">
            Order History
          </a>
        </li>
      </ul>
    )
  }

  render() {
    const item_count = this.state.cart_items.length
    return (
      <li className="dropdown">
        <a
          href="#"
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-expanded="false"
          style={{ backgroundColor: item_count ? 'red' : '' }}
        >
          {this.renderCartMenuButtonContent(item_count)}
        </a>
        {this.renderCartMenu()}
      </li>
    )
  }
}

export default CartNotificationsMenu
